module.exports = __webpack_public_path__ + "img/iba-logo.0b97a4a2.svg";